import { useMemo } from 'react';
import { useMutation, useQuery, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { Roles } from '@/common/constants';
import { API_URL } from '@/dtos';
import { useHasAccess } from '@/modules/core/hooks';

interface Response {
  is_displayed: boolean;
}

export const QUERY_KEY = 'GET_TAX_BANNER';
const useTaxFormsBannerQuery = () => {
  const queryClient = useQueryClient();
  const isLimitedAccess = useHasAccess([
    {
      role: Roles.employeeLimitedAccess,
    },
  ]);

  const { isLoading, isSuccess, data } = useQuery(
    [QUERY_KEY, isLimitedAccess],
    // TODO: the type is missing
    () => api.get<Response>(API_URL.TAX_FORMS_TAX_FORM_BANNER),
    {
      enabled: !isLimitedAccess,
    }
  );

  const { mutateAsync } = useMutation(() => api.patch(API_URL.TAX_FORMS_TAX_FORM_BANNER_DISABLE), {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY],
      });
    },
  });

  const isDisplayed = useMemo(() => data?.data?.is_displayed || false, [data?.data?.is_displayed]);
  return {
    isLoading,
    handleDismiss: mutateAsync,
    isSuccess,
    isDisplayed: isDisplayed,
  };
};

export default useTaxFormsBannerQuery;
